import type { MicrobleedStatus } from "./useMicrobleeds";

/** Status → RGB. Matches the legend (new=red, stable=blue, not_observed=grey). */
export function statusColor(
  status: MicrobleedStatus,
): [number, number, number] {
  if (status === "new") return [255, 60, 60];
  if (status === "stable") return [0, 120, 255];
  if (status === "not_observed") return [120, 120, 120];
  return [180, 180, 180];
}

export function rgbCss([r, g, b]: [number, number, number]) {
  return `rgb(${r},${g},${b})`;
}
